import {
  EnhancedTableHeader,
  EnhancedTableHeaderType,
} from '@components/table/widgets/shared-with-old';
import { IListingFilterWidgetSection } from '@components/widgets/listing-filter-widget';
import { FormInputTypes } from '@components/_old/dynamicForm';
import { IAbstractRecord } from '@models';

export const headers: Record<string, EnhancedTableHeader> = {
  Production_Insured_InsuredCode: {
    name: 'production_Insured_InsuredCode',
    title: 'Code',
    type: EnhancedTableHeaderType.Link,
    urlTemplate: '/production/insured/{production_Insured_Id}',
    openUrlInNewTab: false,
  },
  Production_Insured_FullName: {
    name: 'production_Insured_FullName',
    title: 'Name',
    type: EnhancedTableHeaderType.Link,
    urlTemplate: '/production/insured/{production_Insured_Id}',
    openUrlInNewTab: false,
  },
  BusinessPartner_FullName: {
    name: 'BusinessPartner_FullName',
    title: 'Business Partner',
    type: EnhancedTableHeaderType.Text,
  },
  Person_Email: {
    name: 'production_Insured_Email',
    title: 'Email',
    type: EnhancedTableHeaderType.Text,
  },
  Production_Insured_PhoneDetails: {
    name: 'production_Insured_PhoneNumber',
    title: 'Phone Number',
    type: EnhancedTableHeaderType.IntPhoneNumber,
    disableSort: true,
  },
  Production_Insured_createdOn: {
    name: 'production_Insured_createdOn',
    title: 'Created On',
    type: EnhancedTableHeaderType.Date,
  },
  Production_Insured_modifiedOn: {
    name: 'production_Insured_modifiedOn',
    title: 'Modified On',
    type: EnhancedTableHeaderType.Date,
  },
};

export function filterSectionsContent(
  lovs: Record<string, Record<string, string>>,
  filterValues: IAbstractRecord
): IListingFilterWidgetSection[] {
  const newFilterSections: IListingFilterWidgetSection[] = [
    {
      title: 'Filters',
      inputs: {
        businessPartner: {
          name: 'businessPartner',
          title: 'Business Partner',
          type: FormInputTypes.newmultiselect,
          value: filterValues?.businessPartner || [],
          placeholder: 'Business Partner',
          triggerUpdate: true,
          selectOptions: lovs.businessPartner,
        },
        createdOn: {
          name: 'createdOn',
          title: 'Created On',
          type: FormInputTypes.newdaterange,
          value: filterValues?.createdOn || [],
          placeholder: 'Created On',
          triggerUpdate: true,
        },
      },
    },
  ];
  return newFilterSections;
}
